export const initialDataFilterValues = {
  ap: [
    {
      artId: null,
      bearbeitung: null,
      startJahr: null,
      umsetzung: null,
      bearbeiter: null,
      ekfBeobachtungszeitpunkt: null,
    },
  ],
  pop: [
    {
      nr: null,
      name: null,
      status: null,
      statusUnklar: null,
      statusUnklarBegruendung: null,
      bekanntSeit: null,
    },
  ],
  tpop: [
    {
      nr: null,
      gemeinde: null,
      flurname: null,
      radius: null,
      hoehe: null,
      exposition: null,
      klima: null,
      neigung: null,
      bodenTyp: null,
      bodenKalkgehalt: null,
      bodenDurchlaessigkeit: null,
      bodenHumus: null,
      bodenNaehrstoffgehalt: null,
      bodenAbtrag: null,
      wasserhaushalt: null,
      beschreibung: null,
      katasterNr: null,
      status: null,
      statusUnklar: null,
      statusUnklarGrund: null,
      apberRelevant: null,
      bekanntSeit: null,
      eigentuemer: null,
      kontakt: null,
      nutzungszone: null,
      bewirtschafter: null,
      bewirtschaftung: null,
      ekfrequenz: null,
      ekfrequenzAbweichend: null,
      ekfrequenzStartjahr: null,
      ekfKontrolleur: null,
      bemerkungen: null,
    },
  ],
  tpopfeldkontr: [
    {
      typ: null,
      datum: null,
      jahr: null,
      bearbeiter: null,
      vitalitaet: null,
      ueberlebensrate: null,
      entwicklung: null,
      ursachen: null,
      erfolgsbeurteilung: null,
      umsetzungAendern: null,
      kontrolleAendern: null,
      bemerkungen: null,
      apberNichtRelevant: null,
      apberNichtRelevantGrund: null,
      lrDelarze: null,
      flaeche: null,
      lrUmgebungDelarze: null,
      vegetationstyp: null,
      konkurrenz: null,
      moosschicht: null,
      krautschicht: null,
      strauchschicht: null,
      baumschicht: null,
      idealbiotopUebereinstimmung: null,
      handlungsbedarf: null,
      flaecheUeberprueft: null,
      planVorhanden: null,
      deckungVegetation: null,
      deckungNackterBoden: null,
      deckungApArt: null,
      jungpflanzenVorhanden: null,
      vegetationshoeheMaximum: null,
      vegetationshoeheMittel: null,
      gefaehrdung: null,
    },
  ],
  tpopfreiwkontr: [
    {
      typ: null,
      datum: null,
      jahr: null,
      bearbeiter: null,
      vitalitaet: null,
      ueberlebensrate: null,
      entwicklung: null,
      ursachen: null,
      erfolgsbeurteilung: null,
      umsetzungAendern: null,
      kontrolleAendern: null,
      bemerkungen: null,
      lrDelarze: null,
      flaeche: null,
      lrUmgebungDelarze: null,
      vegetationstyp: null,
      konkurrenz: null,
      moosschicht: null,
      krautschicht: null,
      strauchschicht: null,
      baumschicht: null,
      idealbiotopUebereinstimmung: null,
      handlungsbedarf: null,
      flaecheUeberprueft: null,
      planVorhanden: null,
      deckungVegetation: null,
      deckungNackterBoden: null,
      deckungApArt: null,
      jungpflanzenVorhanden: null,
      vegetationshoeheMaximum: null,
      vegetationshoeheMittel: null,
      gefaehrdung: null,
      apberNichtRelevant: null,
      apberNichtRelevantGrund: null,
      ekfBemerkungen: null,
    },
  ],
  tpopmassn: [
    {
      typ: null,
      beschreibung: null,
      jahr: null,
      datum: null,
      bearbeiter: null,
      bemerkungen: null,
      planVorhanden: null,
      planBezeichnung: null,
      flaeche: null,
      markierung: null,
      anzTriebe: null,
      anzPflanzen: null,
      anzPflanzstellen: null,
      wirtspflanze: null,
      herkunftPop: null,
      sammeldatum: null,
      vonAnzahlIndividuen: null,
      form: null,
      pflanzanordnung: null,
    },
  ],
}
